import { useTranslation } from 'react-i18next';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/ui/PageHeader';
import { FadeIn } from '../components/ui/AnimatedSection';

export default function Linge() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      <PageHeader title={t('linge.title')} subtitle={t('linge.subtitle')} imagePath="/assets/luxury_dressing.webp" />

      <main className="flex-grow py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FadeIn>
            <h2 className="text-3xl md:text-4xl font-serif text-black-deep mb-6">{t('linge.detailTitle')}</h2>
            <div className="w-16 h-1 bg-gold-400 mx-auto mb-8"></div>
            <p className="text-lg font-light text-gray-600 leading-relaxed mb-8">
              {t('linge.desc')}
            </p>
          </FadeIn>
        </div>
      </main>

      <Footer />
    </div>
  );
}
